import React, { Fragment } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import CartProductsPage from "./cartproductspage/CartProductsPage";
import HeaderComponent from "../../../../../structure_components/desktop_screens/header_component/header_component";
import CartHeader from "./cartheader/CartHeader";
import "./CartAndPaymentPage.scss";
import images from "../../../../../../../utilities/images/images";
import CouponCoin from "./couponcoins/CouponCoin";
import useGetCartProducts from "../hooks/cart_products/useGetCartProducts";
import CouponCoinSingleProduct from "./couponcoins/CouponCoinSingleProduct";
import { shouldHideStoreCheckoutHeader } from "../../../../../../../custom_utilities/dashboardBannerNavigation";

const CartAndPaymentPage = ({ token, tokenType, tab, storeCurrentHandbookDetails }) => {
  const history = useHistory();
  const location = useLocation();
  const fromDashboard = shouldHideStoreCheckoutHeader(location);

  const { cartProducts } = useGetCartProducts({ token, tokenType });

  const singleCheckoutProducts =
    location?.state?.cartProducts ??
    (storeCurrentHandbookDetails?.p_id ? [storeCurrentHandbookDetails] : []);

  console.log("tabbbbbbbbbb", tab);

  const goToStore = () => {
    history.push({
      pathname: "/store",
      state: { tab: "hand_books" },
    });
  };

  return (
    <Fragment>
      {!fromDashboard ? <HeaderComponent /> : null}
      <div
        className={`cart_wrapper${
          fromDashboard ? " cart_wrapper--from-dashboard" : ""
        }`}
      >
        <CartHeader exploreMotion={fromDashboard} />

        {tab == "cart" ? (
          cartProducts?.length !== 0 ? (
            <div className="cart_inner_wrapper">
              <CartProductsPage
                token={token}
                tokenType={tokenType}
                cartProducts={cartProducts}
                tab={tab}
              />
              <CouponCoin />
            </div>
          ) : (
            <div className="cart_empty_content_wrapper">
              <img src={images.handbookCartEmptyImg} alt="cart-empty-img" />
              <div className="  hd_text1">Your Cart is Empty</div>
              <div className="  hd_text2">
                Looks like y ou haven’t added anything to your cart yet
              </div>

              <div classNa me="gotostore_btn" onClick={goToStore}>
                <button>Go To Store</button>
              </div>
            </div>
          )
        ) : (
          <div className="cart_inner_wrapper">
            <CartProductsPage
              token={token}
              tokenType={tokenType}
              cartProducts={singleCheckoutProducts}
              tab={tab}
            />
            <CouponCoinSingleProduct product={singleCheckoutProducts[0]} />
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  console.log("state.tabbbbb", state.handBookPaymentData);
  return {
    loader: state.ui.loader,
    token: state.auth.authToken,
    tokenType: state.auth.tokenType,
    tab: state.handBookPaymentData.tab,
    storeCurrentHandbookDetails: state.HandbookSliceReducer.storeCurrentHandbookDetails,
  };
};

export default connect(mapStateToProps, null)(CartAndPaymentPage);
